import React from "react";

export const ArrowRenderer = ({ onMouseDown }) => (
  <div className="Select-arrow-custom" onMouseDown={onMouseDown}>
    <i className="material-icons">expand_more</i>
  </div>
);
